<!--begin: Quick actions -->
<div
  ngbDropdown
  placement="bottom-right"
  autoClose="outside"
  class="dropdown dropdown-fluid"
  ngbTooltip="Communications"
>
  <!--begin::Toggle-->
  <div ngbDropdownToggle class="topbar-item">
    <div class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1">
      <ng-container *ngIf="!useSVG">
        <i [ngClass]="icon"></i>
      </ng-container>
      <ng-container *ngIf="useSVG">
        <span class="svg-icon svg-icon-xl svg-icon-primary" [inlineSVG]="icon"></span>
      </ng-container>
    </div>
  </div>
  <!--end::Toggle-->

  <!--begin::Dropdown-->
  <div
    ngbDropdownMenu
    class="dropdown-menu p-0 m-0 dropdown-menu-fit dropdown-menu-right dropdown-menu-anim-up dropdown-menu-xl"
  >
    <form>
      <!--begin: Header -->
      <div
        class="d-flex flex-column flex-center py-10 bgi-size-cover bgi-no-repeat rounded-top"
        style="background-color: #00aaff"
      >
        <!-- [ngStyle]="{'background-image': 'url('+bgImage+')'}" -->
        <h4 class="text-white font-weight-bold">Communications</h4>
      </div>
      <!--end: Header -->
      <!--begin: Grid Nav -->
      <div class="row row-paddingless">
        <!--begin:Item-->
        <ng-template ngxPermissionsOnly="canAddMeeting">
          <div
            class="col bg-hover-light border-right border-bottom d-flex align-items-center justify-content-center"
            ngbDropdownToggle
          >
            <div (click)="newMeeting()" class="d-block py-10 px-5 text-center">
              <span
                class="svg-icon svg-icon-3x svg-icon-success"
                [inlineSVG]="'./assets/media/svg/icons/Communication/Outgoing-call.svg'"
              ></span>
              <span
                class="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1"
                style="white-space: initial"
                >New Sales Call</span
              >
            </div>
          </div>
        </ng-template>
        <!--end:Item-->

        <!--begin:Item-->
        <ng-template ngxPermissionsOnly="canSendMessage">
          <div
            class="col bg-hover-light border-bottom d-flex align-items-center justify-content-center"
            ngbDropdownToggle
          >
            <div (click)="newMessage()" class="d-block py-10 px-5 text-center">
              <span
                class="svg-icon svg-icon-3x svg-icon-success"
                [inlineSVG]="'./assets/media/svg/icons/Communication/Chat1.svg'"
              ></span>
              <span class="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1"
                >New Message</span
              >
            </div>
          </div>
        </ng-template>
        <!--end:Item-->
      </div>

      <div class="row row-paddingless">
        <!--begin:Item-->
        <ng-template ngxPermissionsOnly="canSendDocuments">
          <div
            class="col bg-hover-light border-right d-flex align-items-center justify-content-center"
            ngbDropdownToggle
          >
            <div (click)="sendDocuments()" class="d-block py-10 px-5 text-center">
              <span
                class="svg-icon svg-icon-3x svg-icon-success"
                [inlineSVG]="'./assets/media/svg/icons/General/marketing.svg'"
              ></span>
              <span class="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1"
                >Marketing Material</span
              >
            </div>
          </div>
        </ng-template>
        <!--end:Item-->
        <!--begin:Item-->
        <ng-template ngxPermissionsOnly="canShareDocument">
          <div
            class="col bg-hover-light d-flex align-items-center justify-content-center"
            ngbDropdownToggle
          >
            <div (click)="shareDocument($event)" class="d-block py-10 px-5 text-center">
              <span
                class="svg-icon svg-icon-3x svg-icon-success"
                [inlineSVG]="'./assets/media/svg/icons/Files/Uploaded-file.svg'"
              ></span>
              <span class="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1"
                >Share Document</span
              >
            </div>
          </div>
        </ng-template>
        <!--end:Item-->
        <!--begin:Item-->
        <!--        <ng-template ngxPermissionsOnly="canAddTask">-->
        <!--          <div class="col" ngbDropdownToggle>-->
        <!--            <div (click)="createTask()" class="d-block py-10 px-5 text-center bg-hover-light border-right border-bottom">-->
        <!--              <span class="svg-icon svg-icon-3x svg-icon-success" [inlineSVG]="'./assets/media/svg/icons/General/Clipboard.svg'"></span>-->
        <!--              <span class="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1">Create Task</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </ng-template>-->
        <!--end:Item-->
      </div>
      <!--      <div class="row row-paddingless">-->
      <!--        <ng-template ngxPermissionsOnly="accessToChatModule">-->
      <!--          <div class="col" ngbDropdownToggle>-->
      <!--            <a [routerLink]="['/timeline/chat']" class="d-block py-10 px-5 text-center bg-hover-light border-right">-->
      <!--              <span class="svg-icon svg-icon-3x svg-icon-success" [inlineSVG]="'./assets/media/svg/icons/Communication/Chat2.svg'"></span>-->
      <!--              <span class="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1">New Chat</span>-->
      <!--            </a>-->
      <!--          </div>-->
      <!--          </ng-template>-->
      <!--      </div>-->
    </form>
  </div>
  <!--end::Dropdown-->
</div>
<!--end: Quick actions -->
